/**
 * Determines the age rating badge for a book based on its tags and bundle
 * @param tags - Array of tags associated with the book
 * @param bundleTitle - Optional bundle title to check for specific collections
 * @returns Age rating string: "U" for mini books and funbox collection, "PG" for all others
 */
export function getAgeRating(tags?: string[] | null, bundleTitle?: string | null): string {
  // Check if book is in Funbox bundle
  if (bundleTitle && bundleTitle.toLowerCase() === "funbox") {
    return "U";
  }
  
  if (!tags || tags.length === 0) return "PG";
  
  // Check if book has "mini" or "funbox" tag for very young children
  const hasYoungChildrenTag = tags.some(tag => {
    const lowerTag = tag.toLowerCase();
    return lowerTag === "mini" || lowerTag === "funbox";
  });
  
  return hasYoungChildrenTag ? "U" : "PG";
}

/**
 * Gets the full age rating description
 */
export function getAgeRatingDescription(tags?: string[] | null): string {
  const rating = getAgeRating(tags);
  return rating === "U" 
    ? "Universal - Suitable for all ages" 
    : "Parental Guidance - Some material may not be suitable for children";
}
